export default "__VITE_ASSET__CKF5rbbT__"